/**
 * HamburgerMenu Component
 * STANDALONE - Extracted from App.jsx
 * Created: 2025-12-23
 *
 * Source lines from original App.jsx:
 * - Lines 372-376: Hamburger button
 * - Lines 738-755: Side menu
 * - Line 757: Overlay
 */

import { useState } from 'react'
import './HamburgerMenu.css'

// Default modules - FINAL LIST
const DEFAULT_MODULES = [
  { name: 'Odds', icon: 'fas fa-percentage' },
  { name: 'MasterList', icon: 'fas fa-list' },
  { name: 'ProofBoard', icon: 'fas fa-table-cells' },
  { name: 'Stats', icon: 'fas fa-database' },        // Includes Data
  { name: 'Arbitrage', icon: 'fas fa-balance-scale' },
  { name: 'Middles', icon: 'fas fa-compress-arrows-alt' },
  { name: '+EV', icon: 'fas fa-chart-line' },
  { name: 'Models', icon: 'fas fa-brain' },          // Includes ModelDocs
  { name: 'System', icon: 'fas fa-server' }          // Operations + Infrastructure (scrapers, receivers, workers, DBs, webhooks, websockets)
]

function HamburgerMenu({
  modules = DEFAULT_MODULES,
  selectedModule = 'Odds',
  onModuleSelect = () => {}
}) {
  const [isOpen, setIsOpen] = useState(false)

  const handleModuleClick = (moduleName) => {
    onModuleSelect(moduleName)
    setIsOpen(false)
  }

  return (
    <>
      {/* Hamburger Button */}
      <button className="hamburger-btn" onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Slide-out Menu */}
      <div className={`side-menu ${isOpen ? 'open' : ''}`}>
        <div className="menu-header">
          <h3>Modules</h3>
          <button className="close-menu" onClick={() => setIsOpen(false)}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        {modules.map((module) => (
          <div
            key={module.name}
            className={`menu-item ${selectedModule === module.name ? 'active' : ''}`}
            onClick={() => handleModuleClick(module.name)}
          >
            <i className={module.icon}></i>
            <span>{module.name}</span>
          </div>
        ))}
      </div>

      {/* Overlay */}
      {isOpen && <div className="menu-overlay" onClick={() => setIsOpen(false)}></div>}
    </>
  )
}

export default HamburgerMenu
